export const roundTwoDecimals = (value: number) => {
  return parseFloat(value.toFixed(2));
};
